import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DynamicHeadingService {
  private heading: string = '';
  private cmsHeading: string;
  private headingSubject: BehaviorSubject<string> = new BehaviorSubject<string>(this.heading);

  getHeading$(): Observable<string> {
    return this.headingSubject.asObservable();
  }

  setHeading(heading: string): void {
    this.heading = heading;
    this.publishNextValue();
  }

  /**
   * Returns the heading text which was received from CMS
   */
  getCmsHeading(): string {
    return this.cmsHeading;
  }

  /**
   * Set the heading text which was received from CMS
   */
  setCmsHeading(heading: string): void {
    this.cmsHeading = heading;
  }

  private publishNextValue(): void {
    this.headingSubject.next(this.heading);
  }
}
